var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 11.0921H13.475L9.40833 15.1587C9.08333 15.4837 9.08333 16.0171 9.40833 16.3421C9.73333 16.6671 10.2583 16.6671 10.5833 16.3421L16.075 10.8504C16.4 10.5254 16.4 10.0004 16.075 9.67539L10.5917 4.17539C10.2667 3.85039 9.74166 3.85039 9.41666 4.17539C9.09166 4.50039 9.09166 5.02539 9.41666 5.35039L13.475 9.42539H4.16666C3.70833 9.42539 3.33333 9.80039 3.33333 10.2587C3.33333 10.7171 3.70833 11.0921 4.16666 11.0921Z",
    fill: "#136162"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.7a1394ea18809c5e0b2e084c3dd1d550.svg";
export { ForwardRef as ReactComponent };